package com.vamvisions.main.pages

import androidx.compose.runtime.Composable
import com.vamvisions.main.core.presentation.navigation.Route
import com.vamvisions.main.i18n.LocalStrings
import com.vamvisions.main.layout.PageChrome
import com.vamvisions.main.layout.PageLayout
import com.vamvisions.main.navigation.AppLink
import org.jetbrains.compose.web.dom.H1
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Text

/** Shown for every unknown path. The address bar keeps the path the user asked for. */
@Composable
fun NotFoundPage(chrome: PageChrome) {
    PageLayout(title = LocalStrings.current.notFoundTitle, chrome = chrome) {
        NotFoundContent(chrome.onNavigate)
    }
}

/** The not-found message with a link home, for any page whose content turns out not to exist. */
@Composable
fun NotFoundContent(onNavigate: (Route) -> Unit) {
    val strings = LocalStrings.current
    H1 { Text(strings.notFoundTitle) }
    P { Text(strings.notFoundMessage) }
    P {
        AppLink(Route.Home, onNavigate) { Text(strings.backToHome) }
    }
}
